var $ = require('jquery');
var ajax = require('util/ajax');


var moderators = {};

/**
 * Periodically refresh a component
 * @param {JQuery} $cmp
 */
moderators.autorefresh = (function () {
    var components = [];
    var refreshFrequency = 30000; // 30 seconds
    var reloadingClass = 'reloading';
    var timeout;

    /**
     * Refresh each component sequentially
     * @param {Number} refreshIndex -- which component to refresh
     */
    var refresh = function (refreshIndex) {
        refreshIndex = refreshIndex || 0;

        var $cmp = components[refreshIndex];
        var refreshData = $cmp.find('.refreshable').data();
        var refreshParams = {
            page_key: refreshData.pageKey,
            component_key: refreshData.componentKey,
            version: window.VERSIONS[refreshData.pageKey] || 1
        };

        $cmp.addClass(reloadingClass);

        $.get(refreshData.url, refreshParams)
            .fail(function () {
                $cmp
                    .removeClass(reloadingClass)
                    .addClass('error');
            })
            .then(function (response) {
                for (var action in response.actions) {
                    window.vkey.handle(response.actions[action], action);
                }
                $cmp.removeClass(reloadingClass);
                if (refreshIndex == components.length-1) {
                    startRefreshing();
                } else {
                    refresh(refreshIndex + 1);
                }
            });
    };

    /**
     * Wait `refreshFrequency` and then start the refresh cycle
     */
    var startRefreshing = function () {
        setTimeout(refresh, refreshFrequency);
    };

    return function ($cmp) {
        components.push($cmp);
        clearTimeout(timeout);
        // don't start refreshing until we've collected all of the components
        timeout = setTimeout(startRefreshing, 100);
    };
})();


module.exports = moderators;
